import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import AboutUs from "@/components/AboutUs";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import FloatingCallButton from "@/components/FloatingCallButton";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <WhyChooseUs />
        <AboutUs />
        <Services />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
      <FloatingCallButton />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
